import appConstants from "../../../../../appConstants";


export const getDefects = (params) =>
  params?.data?.defects
    ?.map((defect) => defect.comments)
    .filter(Boolean)
    .join(', ');


export const getAppTutorialComponentId = (tabId) => {
  const { TrailersGrid, TractorGrid, DollyGrid } = appConstants.gridNames;
  const ASSET_MANAGEMENT_GRIDS = [TrailersGrid,TractorGrid,DollyGrid];
  return ASSET_MANAGEMENT_GRIDS[tabId];
}

export const getScacValue = (showTrailerScacValue, fieldName = 'trailerScac') => {
  return (params) => {
    if (showTrailerScacValue) {
      return params.data[fieldName] || null;
    }
    return "";
  };
};